export const helperFunctions = {
  getExecutionsOfMaintenance: (maintenance, executions) => {
    let executionList = [];
    if (maintenance.executions && maintenance.executions.length > 0) {
      maintenance.executions.forEach((executionId) => {
        if (executions[executionId]) {
          executionList.push(executions[executionId]);
        }
      });
    }
    return executionList;
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/WorkOrderReport/OpenReport/Helper.js